import Grid from "@mui/material/Grid2";
import { Box, InputLabel, Typography } from "@mui/material";

import { displayFlex, flexRow } from "../../styles/mui/styles/display";
import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";
import { Asterisk } from "../../styles/common/style";
import { InformationTestStyle, TextLabelFontStyle } from "../styles/styles";

export const label = (label: string, mandate?: boolean, font?: boolean) => {
  return (
    <Grid size={{ xs: 12 }} sx={flexRow} pb={1}>
      <Typography
        variant="h5"
        color={colors.fonts[5]}
        fontWeight={font ? fontWeight[4] : fontWeight[3]}
      >
        {label}
      </Typography>
      {mandate && (
        <Typography
          variant="subtitle1"
          color={colors.red[90]}
          fontWeight={fontWeight[4]}
          pr={2}
          sx={Asterisk}
        >
          *
        </Typography>
      )}
    </Grid>
  );
};

export const TextLabel = (label: string, mandate?: boolean) => {
  return (
    label && (
      <InputLabel shrink={true} sx={displayFlex}>
        <Box sx={displayFlex}>
          <Typography
            variant="h4"
            fontWeight={fontWeight[3]}
            color={colors.fonts[2]}
            lineHeight={"0.95rem"}
          >
            {label}
          </Typography>
          {mandate && (
            <Typography
              variant="subtitle1"
              color={colors.red[90]}
              fontWeight={fontWeight[4]}
              pr={2}
              sx={Asterisk}
            >
              *
            </Typography>
          )}
        </Box>
      </InputLabel>
    )
  );
};

export const TextfieldLabel = (
  label: string,
  mandate?: boolean,
  small?: boolean
) => {
  return (
    label && (
      <Box sx={displayFlex}>
        <Typography
          variant={small ? "h3" : "h2"}
          fontWeight={fontWeight[2]}
          color={colors.portalColor[2]}
          lineHeight={"0.95rem"}
        >
          {label}
        </Typography>
        {mandate && (
          <Typography
            variant="subtitle1"
            color={colors.red[90]}
            fontWeight={fontWeight[4]}
            pr={2}
            sx={Asterisk}
          >
            *
          </Typography>
        )}
      </Box>
    )
  );
};

export const AuthTextLabel = (label: string, mandate?: boolean) => {
  return (
    label && (
      <InputLabel shrink={true} sx={displayFlex}>
        <Box mb={0.5} sx={displayFlex}>
          <Typography
            variant="h4"
            sx={TextLabelFontStyle}
            fontWeight={fontWeight[5]}
            color={colors.portalColor[19]}
            lineHeight={"0.95rem"}
          >
            {label}
          </Typography>
          {mandate && (
            <Typography
              variant="subtitle1"
              color={colors.red[90]}
              fontWeight={fontWeight[4]}
              pr={2}
              sx={Asterisk}
            >
              *
            </Typography>
          )}
        </Box>
      </InputLabel>
    )
  );
};

export const InformationText = (
  text: string,
  font: string,
  style: any,
  color: string,
  isAlert?: boolean
) => {
  return (
    <>
      <Typography
        sx={style}
        variant="h6"
        color={color}
        fontWeight={font}
        lineHeight={"1.5rem"}
      >
        {isAlert && (
          <Box component="span" sx={InformationTestStyle}>
            ALERT:
          </Box>
        )}
        {text}
      </Typography>
    </>
  );
};

 export const TypographyBox = (
    value: string,
    color: string,
    fontWeight: string,
    sx?: object
  ) => {
    return (
      <Typography variant="h6" fontWeight={fontWeight} color={color} sx={sx}>
        {value}
      </Typography>
    );
  };